module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.woff?v=1.9.32
// module id = 114
// module chunks = 1